import { render, staticRenderFns } from "./PettyEditComponent.vue?vue&type=template&id=8d603b98"
import script from "./PettyEditComponent.vue?vue&type=script&lang=js"
export * from "./PettyEditComponent.vue?vue&type=script&lang=js"
import style0 from "./PettyEditComponent.vue?vue&type=style&index=0&id=8d603b98&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports